import React from "react";
import Chip from "@mui/material/Chip";
import { getPayedInvoiceStatusColorv2 } from "utils/colors";

export default function PointStatusChip({ point, connected = false }) {
  let color = connected ? "success" : getPayedInvoiceStatusColorv2(point);
  let label = "";

  return <Chip sx={{ width: "55px" }} label={point} color={color} />;
}
